"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tracker_1 = require("./Tracker");
exports.default = Tracker_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Tracker/index.js
// module id = 1829
// module chunks = 8